import { Injectable } from '@angular/core';
import {
  CanMatch,
  Route,
  Router,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { catchError, map, Observable, of, switchMap, take } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanMatch {
  constructor(private auth: AuthService, private router: Router) {}

  canMatch(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean | UrlTree> {
    return this.auth.isAuthenticated$.pipe(
      take(1),
      switchMap(isAuthenticated => {
        if (isAuthenticated) {
          return of(true);
        }

        return this.auth.checkSession().pipe(
          map(response => {
            if (response && response.status === 'SUCCESS' && response.content) {
              return true;
            }
            return this.router.createUrlTree(['/login']);
          }),
          catchError(() => {
            return of(this.router.createUrlTree(['/login']));
          })
        );
      })
    );
  }
}
